import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import config from '../includes/ConfigFile';

const WriterDetails = () => {
  const { writerId } = useParams();
  const [writer, setWriter] = useState(null);
  const [stories, setStories] = useState([]);

  useEffect(() => {
    // Fetch writer details
    axios.get(`${config.BASE_URL}/api/writersDetails/${writerId}`)
      .then(res => setWriter(res.data.writer))
      .catch(err => console.error('Error fetching writer:', err));

    // Fetch writer's posts
    axios.get(`${config.BASE_URL}/api/writersDetails/${writerId}/stories`)
      .then(res => setStories(res.data.stories))
      .catch(err => console.error('Error fetching stories:', err));
  }, [writerId]);

  if (!writer) return <p className="text-center mt-5">Loading...</p>;

  return (
    <div className="container mt-4">
      <div className="row mb-4">
        <div className="col-md-3">
          <img 
            src={`${writer.profile_picture}`} 
            alt={writer.name} 
            className="img-fluid rounded shadow" 
          />
        </div>
        <div className="col-md-9">
          <h2>{writer.name}</h2>
          <p><b>Bio:</b> {writer.bio}</p>
          <p><b>Email:</b> {writer.email}</p>
        </div>
      </div>

      <hr />

      <h3 className="mb-3">Stories by {writer.name}</h3>
      <div className="row">
        {stories.length > 0 ? (
          stories.map(story => (
            <div key={story.id} className="col-md-4 mb-4">
              <div className="card shadow-sm">
                <img 
                  src={`${config.BASE_URL}/public/uploads/admin/post/${story.post_image}`} 
                  className="card-img-top rounded shadow"
                  alt={story.title} 
                  style={{
                    maxWidth:"100%",height:"400px"
                  }}
                  
                />
                <div className="card-body">
                  <h5 className="card-title">{story.post_title}</h5>
                  <p className="card-text">{story.post_short_description}</p>
                  <Link to={`/chapter/${story.first_chapter}/${story.id}`} className="btn btn-primary btn-sm">
                    Read Now
                  </Link>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No stories found.</p>
        )}
      </div>
    </div>
  );
};

export default WriterDetails;
